import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-overlay',
  templateUrl: './common-overlay.component.html',
  styleUrls: ['./common-overlay.component.styl'],
})
export class CommonOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
